"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerFooterButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _button = require("../../../button");
// a faux-medium-button.
const DatePickerFooterButton = (0, _styled.default)(_button.Button)`
    height: 32px;
    min-width: 96px;
    font-weight: 600;
`;
exports.DatePickerFooterButton = DatePickerFooterButton;
//# sourceMappingURL=DatePickerFooterButton.js.map